import Grid from '@mui/material/Grid2';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableFooter from '@mui/material/TableFooter';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TablePaginationActions from '../molecules/TablePaginationActions';
import { JOB_SUMMARY_ROWS_PER_PAGE_OPTIONS } from '../../constants';
import { formatDisplayedRows } from '../../utils/format';
import type { JobSummaryRow } from '../../interfaces/Dashboard';

const COLUMN_COUNT = 5;

interface JobSummaryTableProps {
  rows: JobSummaryRow[];
  page: number;
  rowsPerPage: number;
  onPageChange: (page: number) => void;
  onRowsPerPageChange: (rowsPerPage: number) => void;
}

/** Error/log detail grid rendered inside the job-summary modal. */
const JobSummaryTable = ({
  rows,
  page,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
}: JobSummaryTableProps) => {
  const visibleRows = rows.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage,
  );

  return (
    <Grid container spacing={3} className='request-container'>
      <Grid size={12}>
        <Paper className='category-paper-wrapper' sx={{ width: '100%' }}>
          <TableContainer className='request-table-list'>
            <Table aria-label='job summary details' size='small'>
              <TableHead className='request-table-list-header'>
                <TableRow>
                  <TableCell align='left'>ROI Request ID</TableCell>
                  <TableCell align='left'>Request ID</TableCell>
                  <TableCell align='left'>Error Response</TableCell>
                  <TableCell align='left'>Log Summary</TableCell>
                  <TableCell align='left'>Resource URL</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {visibleRows.map((row, index) => (
                  <TableRow
                    key={row.id ?? row.requestid + '-' + index}
                    className='request-table-row'
                  >
                    <TableCell
                      align='left'
                      className='request-table-column name capital-text'
                      title={row.requesterrefid}
                    >
                      {row.requesterrefid}
                    </TableCell>
                    <TableCell
                      align='left'
                      className='request-table-column name capital-text'
                      title={row.requestid}
                    >
                      {row.requestid}
                    </TableCell>
                    <TableCell
                      align='left'
                      className='request-table-column name capital-text'
                      title={row.errorresponse}
                    >
                      {row.errorresponse}
                    </TableCell>
                    <TableCell
                      align='left'
                      className='request-table-column name capital-text'
                      title={row.logsummary}
                    >
                      {row.logsummary}
                    </TableCell>
                    <TableCell
                      align='left'
                      className='request-table-column name capital-text'
                      title={row.resourceurl}
                    >
                      {row.resourceurl}
                    </TableCell>
                  </TableRow>
                ))}

                {rows.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={COLUMN_COUNT} align='center'>
                      No Record Found
                    </TableCell>
                  </TableRow>
                ) : null}
              </TableBody>

              {rows.length > 0 ? (
                <TableFooter>
                  <TableRow>
                    <TablePagination
                      rowsPerPageOptions={JOB_SUMMARY_ROWS_PER_PAGE_OPTIONS}
                      colSpan={COLUMN_COUNT}
                      count={rows.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      labelDisplayedRows={formatDisplayedRows}
                      slotProps={{
                        select: {
                          inputProps: { 'aria-label': 'rows per page' },
                          native: true,
                        },
                      }}
                      onPageChange={(_event, newPage) => onPageChange(newPage)}
                      onRowsPerPageChange={(event) =>
                        onRowsPerPageChange(parseInt(event.target.value, 10))
                      }
                      ActionsComponent={TablePaginationActions}
                    />
                  </TableRow>
                </TableFooter>
              ) : null}
            </Table>
          </TableContainer>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default JobSummaryTable;
